export default [{
  path: '/login',
  component: resolve => require(['@/components/login/view/login.vue'], resolve)
}]



// WEBPACK FOOTER //
// ./src/components/login/router/router.js